import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Tabs,
  Tab,
  Checkbox,
  TextField,
  Autocomplete,
  Card,
  CardHeader,
  Popover,
  CardActions,
  CardContent,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Avatar,
  Skeleton,
  Alert,
  AlertTitle,
  Stack,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { connect } from "react-redux";
import {
  removeDuplicates,
  requestStatusColor,
  textCapitalized,
} from "../../common/components/Utils";
import moment from "moment";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { a11yProps } from "../../common/components/TabPanel";
import { getHeadOfInstitution } from "../../../store/structure/actions";
import { getUserDetails } from "../../../store/profile/actions";
import ViewCaseLogs from "./ViewCaseLogs";
import ViewCaseAttachments from "./ViewCaseAttachments";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import {
  getFaultWithSanction,
  updateCaseFault,
  removeCaseFault,
  updateCaseDesc,
  updateCaseIDCReport,
  closeCaseRequest,
  getCaseLetters,
  signLetter,
  suspendEmployeeProvisionally,
  onInitiateExplanationFeedbackLetter,
  onInitiateProvisionalSuspensionLetter,
  onInitiateSanctionLetter,
  onViewLetter,
  updateCaseAppointingAuthority,
  notifyCaseAppointingAuthority,
} from "../../../store/discipline/actions";
import { getAllPlanningEntities } from "../../../store/rbm/actions";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import CommitteeReportFormDialog from "./CommitteeReportFormDialog";
import { showError } from "../../toastify";
import ViewLetterDialog from "./ViewLetterDialog";
import SignLetter from "../../documents/LetterFormat/SignLetter";
import AddIcon from "@mui/icons-material/Add";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ActionButton from "../../common/components/ActionButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const ViewCaseDialog = (props) => {
  const {
    showCaseDetail,
    setShowCaseDetail,
    caseRequest,
    updateCaseFault,
    getFaultWithSanction,
    removeCaseFault,
    updateCaseDesc,
    closeCaseRequest,
    faults,
    caseLetters,
    getCaseLetters,
    signLetter,
    suspendEmployeeProvisionally,
    onInitiateExplanationFeedbackLetter,
    onViewLetter,
    onInitiateSanctionLetter,
    updateCaseIDCReport,
    onInitiateProvisionalSuspensionLetter,
    allPlanningEntities,
    getAllPlanningEntities,
    updateCaseAppointingAuthority,
    notifyCaseAppointingAuthority,
    user,
  } = props;
  const { hasPermissions } = useRequiredAuth();

  const uniquePlanningEntities = useMemo(() => {
    if (!Array.isArray(allPlanningEntities)) return [];
    const seen = new Set();
    return allPlanningEntities.filter((entity) => {
      if (!entity || !entity.id) return false;
      if (seen.has(entity.id)) return false;
      seen.add(entity.id);
      return true;
    });
  }, [allPlanningEntities]);

  const [
    showAppointingAuthorityEditDialog,
    setShowAppointingAuthorityEditDialog,
  ] = useState(false);
  const [
    showSendToAppointingAuthorityConfirm,
    setShowSendToAppointingAuthorityConfirm,
  ] = useState(false);
  const [
    selectedForSendToAppointingAuthority,
    setSelectedForSendToAppointingAuthority,
  ] = useState(null);
  const [loadingSendToAaOptions, setLoadingSendToAaOptions] = useState(false);
  const [
    selectedAppointingAuthorityPlanningEntity,
    setSelectedAppointingAuthorityPlanningEntity,
  ] = useState(null);
  const [loadingPlanningEntities, setLoadingPlanningEntities] = useState(false);
  const [showAddFaultForm, setShowAddFaultForm] = useState(false);
  const [showRemoveFaultForm, setShowRemoveFaultForm] = useState(false);
  const [showCaseDescForm, setShowCaseDescForm] = useState(false);

  const [
    showCaseReportCommitteeSummaryForm,
    setShowCaseReportCommitteeSummaryForm,
  ] = useState(false);

  const [showCaseReportCommitteeDateForm, setShowCaseReportCommitteeDateForm] =
    useState(false);
  const [isSuspended, setIsSuspended] = useState(
    caseRequest?.request?.isSuspended,
  );
  const [showCommitteeReportForm, setShowCommitteeReportForm] = useState(false);
  const [showCloseCaseDialog, setShowCloseCaseDialog] = useState(false);
  const [showSuspendEmployeeDialog, setShowSuspendEmployeeDialog] =
    useState(false);
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [caseDescription, setCaseDescription] = useState(
    caseRequest?.request?.caseDescription || null,
  );
  const [reportCommitteeSummary, setReportCommitteeSummary] = useState(
    caseRequest?.request?.reportCommitteeSummary || null,
  );
  const [reportCommitteeDate, setReportCommitteeDate] = useState(
    caseRequest?.request?.reportCommitteeDate || null,
  );

  const [showFault, setShowFault] = useState(null);
  const [tmpFaults, setTmpFaults] = useState([]);
  // console.log(caseRequest?.request);
  const [isEditable, setIsEditable] = useState(
    hasPermissions(["IS_SANCTION_INITIATOR", "IS_HR"]) &&
      +caseRequest?.request?.currentLetterTypeId === 1 &&
      +caseRequest?.request?.currentLetterStatusId === 1
      ? true
      : false,
  );

  const [filteredFaults, setFilteredFaults] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    getCaseLetters(caseRequest?.request?.id || "", setIsLoading);
  }, [caseRequest, getCaseLetters]);
  useEffect(() => {
    if (!faults.length) getFaultWithSanction();
  }, [faults.length, getFaultWithSanction]);

  useEffect(() => {
    if (!!faults.length) {
      let _tmpFaults = [];
      faults.forEach((fault) => {
        if (!caseRequest?.faults.find(({ faultId }) => fault.id === faultId)) {
          _tmpFaults.push(fault);
        }
      });
      setFilteredFaults(_tmpFaults);
    }
  }, [caseRequest, faults]);

  useEffect(() => {
    setCaseDescription(caseRequest?.request?.caseDescription || null);
    setReportCommitteeSummary(
      caseRequest?.request?.reportCommitteeSummary || null,
    );
    setReportCommitteeDate(caseRequest?.request?.reportCommitteeDate || null);

    setIsEditable(
      +caseRequest?.request?.currentLetterTypeId === 1 &&
        +caseRequest?.request?.currentLetterStatusId === 1
        ? true
        : false,
    );
  }, [caseRequest]);

  useEffect(() => {
    if (!showAppointingAuthorityEditDialog) return;
    if (!uniquePlanningEntities.length) {
      getAllPlanningEntities((status) => setLoadingPlanningEntities(status));
    }
  }, [
    showAppointingAuthorityEditDialog,
    uniquePlanningEntities.length,
    getAllPlanningEntities,
  ]);

  useEffect(() => {
    if (!showAppointingAuthorityEditDialog) return;
    const id = caseRequest?.request?.appointingAuthorityPlanningEntityId;
    if (!id) {
      setSelectedAppointingAuthorityPlanningEntity(null);
      return;
    }
    const fromList = uniquePlanningEntities.find((e) => e.id === id);
    setSelectedAppointingAuthorityPlanningEntity(
      fromList ||
        (caseRequest?.request?.appointingAuthorityName
          ? { id, name: caseRequest.request.appointingAuthorityName }
          : null),
    );
  }, [
    showAppointingAuthorityEditDialog,
    caseRequest?.request?.appointingAuthorityPlanningEntityId,
    caseRequest?.request?.appointingAuthorityName,
    uniquePlanningEntities,
  ]);

  useEffect(() => {
    if (!showSendToAppointingAuthorityConfirm) return;
    if (!uniquePlanningEntities.length) {
      getAllPlanningEntities((status) => setLoadingSendToAaOptions(status));
    }
  }, [
    showSendToAppointingAuthorityConfirm,
    uniquePlanningEntities.length,
    getAllPlanningEntities,
  ]);

  useEffect(() => {
    if (!showSendToAppointingAuthorityConfirm) return;
    const id = caseRequest?.request?.appointingAuthorityPlanningEntityId;
    if (!id) {
      setSelectedForSendToAppointingAuthority(null);
      return;
    }
    const fromList = uniquePlanningEntities.find((e) => e.id === id);
    setSelectedForSendToAppointingAuthority(
      fromList ||
        (caseRequest?.request?.appointingAuthorityName
          ? { id, name: caseRequest.request.appointingAuthorityName }
          : null),
    );
  }, [
    showSendToAppointingAuthorityConfirm,
    caseRequest?.request?.appointingAuthorityPlanningEntityId,
    caseRequest?.request?.appointingAuthorityName,
    uniquePlanningEntities,
  ]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onClose = () => {
    setShowCaseDetail(false);
  };

  const handleConfirmSuspension = () => {
    suspendEmployeeProvisionally(caseRequest?.request.id, reason, () => {
      setReason("");
      setIsSuspended((prev) => !prev); // Toggle the switch state after confirmation
      setShowSuspendEmployeeDialog(false); // Close the dialog
    });
  };

  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showCaseDetail}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle className="text-primary">
          <div className="row">
            <div className="col-9">
              <h5>
                View Case #{caseRequest?.request?.id}
                {caseRequest?.request?.caseStatusId === 1 &&
                  caseRequest?.request?.currentLetterStatusId &&
                  caseRequest?.request?.currentLetterDesc && (
                    <>
                      {" "}
                      -
                      {caseRequest?.request?.reportCommitteeSummary &&
                      caseRequest?.request?.currentLetterStatusId === 2 &&
                      caseRequest?.request?.currentLetterTypeId === 6 ? (
                        <>
                          <span
                            style={{ fontSize: "14px" }}
                            className={`px-1 text-warning`}
                          >
                            The report of the Internal Disciplinary Committee
                            has been submitted.
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            className="py-0 px-1 text-secondary"
                            style={{ fontSize: "15px" }}
                          >
                            {" "}
                            {caseRequest.request.currentLetterDesc}
                          </span>{" "}
                          <span
                            className="py-0 px-0"
                            style={{ fontSize: "15px" }}
                          >
                            -
                          </span>
                          <span
                            style={{ fontSize: "15px" }}
                            className={`py-0 px-1 text-${requestStatusColor(
                              [
                                {
                                  className: `${
                                    caseRequest.request
                                      .currentLetterStatusId === 1
                                      ? "warning"
                                      : "success"
                                  }`,
                                  statusIds: [
                                    +caseRequest.request.currentLetterStatusId,
                                  ],
                                },
                              ],
                              caseRequest.request.currentLetterStatusId,
                            )}`}
                          >
                            {caseRequest.request.currentLetterStatusName}
                          </span>
                        </>
                      )}
                    </>
                  )}
              </h5>
            </div>
            <div className="col-3">
              <div className="row">
                <div className="col"></div>
                <div className="col">
                  <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 2,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <span className="material-icons">close</span>
                  </IconButton>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col">
                  <Tabs
                    className="mt-2"
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="tabs"
                    allowScrollButtonsMobile
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab
                      className="text-capitalize"
                      label="Details"
                      {...a11yProps(0)}
                    />

                    <Tab
                      className="text-capitalize"
                      label="Approver's Logs"
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </div>
                <div className="col text-right float-right">
                  <span
                    className={`badge mt-3 mx-1 badge-${requestStatusColor(
                      [
                        {
                          className: "primary",
                          statusIds: [1],
                        },
                        {
                          className: "success",
                          statusIds: [2],
                        },
                      ],
                      caseRequest.request.caseStatusId,
                    )}`}
                  >
                    {caseRequest.request.caseStatusName}
                  </span>
                  {["WAITING_TO_CLOSE_CASE"].includes(
                    caseRequest?.request?.decisionTaken,
                  ) &&
                    hasPermissions([
                      "IS_HEAD_OF_INSTITUTION",
                      "IS_HEAD_OF_INSTITUTION_ACTING",
                    ]) && (
                      <Button
                        className="mx-1"
                        variant="contained"
                        color="warning"
                        startIcon={<DoNotDisturbOnIcon />}
                        style={{ textTransform: "none" }}
                        onClick={() => {
                          setReason("");
                          setShowCloseCaseDialog(true);
                        }}
                      >
                        Click here to close the case!
                      </Button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="mt-0 mx-4" dividers>
          {tabValue === 0 && (
            <Box sx={{ width: "100%", minHeight: "80vh" }} className="mt-1">
              <React.Fragment>
                <Typography component={"div"} sx={{ mt: 0, mb: 1 }}>
                  {caseRequest && caseRequest?.request && (
                    <Card
                      className={`rounded hoverable-card mb-2 mt-2 pb-3`}
                      variant="outlined"
                      sx={{
                        backgroundColor: `#cdeef8`,
                        border: "none",
                      }}
                    >
                      <CardHeader
                        className="pb-0 pt-2"
                        avatar={
                          <Tooltip title={caseRequest.request.firstName}>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                                cursor: "default",
                              }}
                            >
                              <Avatar
                                sizes="large"
                                style={{
                                  border: "1px solid #d1cbcb",
                                }}
                                alt={caseRequest.request.firstName}
                                className=""
                                src={`data:image/jpg;base64,${caseRequest?.profilePicture}`}
                              />
                            </Box>
                          </Tooltip>
                        }
                        title={
                          <span
                            className="d-flex flex-column"
                            // style={{ maxWidth: "400px" }}
                          >
                            <span className="d-flex align-items-center text-uppercase font-weight-bold text-primary">
                              {caseRequest.request.firstName}{" "}
                              {caseRequest.request.lastName}
                            </span>
                            <span className="d-block text-primary ml-1 p-1 text-sm">
                              {caseRequest.request.positionName}{" "}
                              {caseRequest.request.unitName ? (
                                <strong className="text-dark">
                                  @
                                  {String(
                                    caseRequest.request.unitName,
                                  ).toUpperCase()}
                                </strong>
                              ) : null}
                            </span>
                          </span>
                        }
                        subheader={
                          <span className="d-flex align-items-center flex-wrap justify-content-between ">
                            <span className="d-flex align-items-center flex-wrap">
                              <span className="">
                                <span className="d-flex align-items-center  flex-wrap">
                                  <span
                                    className={`d-flex align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                    style={{
                                      cursor: "default",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <span className={`badge badge-primary m-1`}>
                                      {caseRequest.request.totalCases || 0}
                                    </span>
                                    All cases
                                  </span>

                                  <span
                                    className={`d-flex align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                    style={{
                                      cursor: "default",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <span className={`badge badge-warning m-1`}>
                                      {caseRequest.request.totalOngoing || 0}
                                    </span>
                                    Ongoing
                                  </span>

                                  <span
                                    className={`d-flex  align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                                    style={{
                                      cursor: "default",
                                      // borderRight: "2px solid #ccd0d6",
                                      // borderLeft: "2px solid #ccd0d6",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <span
                                      className={`badge badge-secondary m-1`}
                                    >
                                      {caseRequest.request.totalClosed || 0}
                                    </span>
                                    Closed Cases
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        }
                      />
                    </Card>
                  )}

                  {!!caseRequest?.request
                    ?.appointingAuthorityPlanningEntityId && (
                    <div className="card service-card valid mb-2 mt-2">
                      <div
                        className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
                        style={{ padding: "0.5rem 1.2rem" }}
                      >
                        <div className="d-flex flex-column pr-2 min-w-0">
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                            className="text-uppercase font-weight-bold"
                          >
                            Appointing authority
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            className="font-weight-bold text-primary text-break"
                          >
                            {caseRequest.request.appointingAuthorityName}
                          </Typography>
                        </div>
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={1}
                          flexShrink={0}
                        >
                          {hasPermissions([
                            "IS_SANCTION_INITIATOR",
                            "IS_HEAD_OF_INSTITUTION",
                            "IS_HEAD_OF_INSTITUTION_ACTING",
                            "IS_HR",
                          ]) &&
                            caseRequest?.request?.approverPlanningEntityId ===
                              caseRequest?.request?.planningEntityId && (
                              <>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="primary"
                                  startIcon={<EditOutlinedIcon />}
                                  disabled={
                                    caseRequest.request.caseStatusId === 2
                                  }
                                  onClick={() =>
                                    setShowAppointingAuthorityEditDialog(true)
                                  }
                                  style={{
                                    marginRight: "10px",
                                    textTransform: "none",
                                  }}
                                >
                                  Edit
                                </Button>
                                {["GIVE_SANCTION"].includes(
                                  caseRequest?.request?.decisionTaken,
                                ) && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="success"
                                    startIcon={
                                      !caseRequest?.request
                                        ?.isSentToAppointingAuthority ? (
                                        <SendOutlinedIcon />
                                      ) : null
                                    }
                                    disabled={
                                      caseRequest.request.caseStatusId === 2 ||
                                      !!caseRequest?.request
                                        ?.isSentToAppointingAuthority
                                    }
                                    onClick={() =>
                                      setShowSendToAppointingAuthorityConfirm(
                                        true,
                                      )
                                    }
                                    style={{
                                      marginRight: "10px",
                                      textTransform: "none",
                                    }}
                                  >
                                    {caseRequest?.request
                                      ?.isSentToAppointingAuthority
                                      ? "Sent to appointing authority"
                                      : "Click here to submit to"}{" "}
                                    {!caseRequest?.request
                                      ?.isSentToAppointingAuthority && (
                                      <strong className="ml-1 text-uppercase">
                                        {caseRequest?.request
                                          ?.appointingAuthorityNameAcronym ||
                                          "Appointing Authority"}
                                      </strong>
                                    )}
                                  </Button>
                                )}
                              </>
                            )}
                        </Stack>
                      </div>
                    </div>
                  )}

                  {hasPermissions(["IS_SANCTION_INITIATOR"]) &&
                  ((caseRequest?.request?.approverPlanningEntityId ===
                    caseRequest?.request?.planningEntityId &&
                    !caseRequest?.request?.isSentToAppointingAuthority) ||
                    (caseRequest?.request?.approverPlanningEntityId ===
                      caseRequest?.request
                        ?.appointingAuthorityPlanningEntityId &&
                      caseRequest?.request?.isSentToAppointingAuthority)) ? (
                    <div className="card service-card valid mb-2 mt-2">
                      <div
                        className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
                        style={{ padding: "0.5rem 1.2rem" }}
                      >
                        <div className="d-flex flex-column pr-2 min-w-0">
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                            className="text-uppercase font-weight-bold"
                          >
                            Sanction letter
                          </Typography>
                          {/* <Typography
                            variant="subtitle1"
                            className="font-weight-bold text-primary text-break"
                          >
                            Impose sanction
                          </Typography> */}
                          <Typography
                            variant="body2"
                            sx={{ color: "text.success", mt: 0.5 }}
                            className="text-break"
                          >
                            Choose the sanction type, dates, and reason, then
                            generate the letter for review when the case is
                            ready after committee feedback.
                          </Typography>
                        </div>
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={1}
                          flexShrink={0}
                        >
                          <GiveSanctionButton
                            caseRequest={caseRequest}
                            faults={faults}
                            onClose={onClose}
                            onInitiateSanctionLetter={onInitiateSanctionLetter}
                            disabled={
                              caseRequest?.request.caseStatusId === 2 ||
                              !(
                                ["GIVE_SANCTION"].includes(
                                  caseRequest?.request?.decisionTaken,
                                ) &&
                                +caseRequest?.request?.currentLetterTypeId ===
                                  6 &&
                                +caseRequest?.request?.currentLetterStatusId ===
                                  2
                              ) ||
                              [2, 3, 4, 7].includes(
                                +caseRequest?.request?.currentLetterTypeId,
                              )
                            }
                          />
                        </Stack>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}

                  {hasPermissions(["IS_HR"]) ? (
                    <div className="card service-card valid mb-2 mt-2">
                      <div
                        className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
                        style={{ padding: "0.5rem 1.2rem" }}
                      >
                        <div className="d-flex flex-column pr-2 min-w-0">
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                            className="text-uppercase font-weight-bold"
                          >
                            Internal disciplinary committee
                          </Typography>
                          {/* <Typography
                            variant="subtitle1"
                            className="font-weight-bold text-primary text-break"
                          >
                            Submit IDC report
                          </Typography> */}
                          <Typography
                            variant="body2"
                            sx={{ color: "text.success", mt: 0.5 }}
                            className="text-break"
                          >
                            Record the committee&apos;s findings and key dates
                            for this case after the IDC has concluded and the
                            workflow expects the report.
                          </Typography>
                        </div>
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={1}
                          flexShrink={0}
                        >
                          <Button
                            disabled={
                              caseRequest?.request?.caseStatusId === 2 ||
                              caseRequest?.request?.reportCommitteeSummary ||
                              !(
                                ["SUBMIT_TO_COMMITTEE"].includes(
                                  caseRequest?.request?.decisionTaken,
                                ) &&
                                +caseRequest?.request?.currentLetterTypeId ===
                                  6 &&
                                +caseRequest?.request?.currentLetterStatusId ===
                                  2
                              )
                            }
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AssessmentIcon />}
                            style={{
                              marginRight: "10px",
                              textTransform: "none",
                            }}
                            onClick={() => {
                              setShowCommitteeReportForm(true);
                            }}
                          >
                            Click here to submit IDC report
                          </Button>
                        </Stack>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}

                  <div className="card service-card valid mb-2 mt-3">
                    <div
                      className="card-header  d-flex justify-content-between align-items-center"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      <strong> I. Case letters</strong>
                      {/* {hasPermissions(["IS_HR"]) && ( */}
                      {/* <div className="text-right">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isSuspended}
                              // color={isSuspended ? "error" : "primary"}
                            />
                          }
                          label="Provisional Suspension"
                          onChange={() => setShowSuspendEmployeeDialog(true)}
                          disabled={caseRequest.request.caseStatusId === 2}
                        />

                        
                      </div> */}
                      {/* )} */}

                      {showSuspendEmployeeDialog && (
                        <ConfirmationDialog
                          fullWidth
                          confirmationDialog={showSuspendEmployeeDialog}
                          disabled={!reason}
                          message={
                            <>
                              <div className="text-left">
                                {/* Are you sure you want to
                                <strong className="text-warning mx-1">
                                  {isSuspended ? "unsuspend" : "suspend"}
                                </strong>
                                <span className="contact_span">
                                  <span className="mx-1">
                                    {textCapitalized(
                                      caseRequest?.request?.lastName
                                    )}{" "}
                                    {textCapitalized(
                                      caseRequest?.request?.firstName
                                    )}
                                  </span>
                                </span> */}

                                <TextField
                                  autoFocus
                                  fullWidth
                                  className="mt-2"
                                  size="small"
                                  multiline
                                  rows={4}
                                  name="reason"
                                  label={`Reason for ${
                                    isSuspended ? "unsuspension" : "suspension"
                                  } `}
                                  variant="outlined"
                                  placeholder={`Reason for ${
                                    isSuspended ? "unsuspension" : "suspension"
                                  } `}
                                  value={reason}
                                  onChange={(e) =>
                                    setReason(e.target.value || "")
                                  }
                                />
                              </div>
                            </>
                          }
                          setConfirmationDialog={setShowSuspendEmployeeDialog}
                          onYes={handleConfirmSuspension}
                        />
                      )}
                    </div>
                    <div className="card-body">
                      {!caseLetters.length && isLoading && (
                        <div>
                          <Skeleton
                            variant="rectangular"
                            className="mb-3 mt-2"
                            height={118}
                          />
                          <Skeleton
                            variant="rectangular"
                            className="mb-3"
                            height={96}
                          />
                          <Skeleton
                            variant="rectangular"
                            className="mb-3"
                            height={96}
                          />
                          <Skeleton
                            variant="rectangular"
                            className="mb-3"
                            height={96}
                          />
                        </div>
                      )}

                      {/* {caseRequest &&
                        caseRequest?.request &&
                        !!caseRequest?.request?.isEmployeeDelayedToRespond && (
                          <Card
                            className={`rounded hoverable-card mb-2 pb-0`}
                            variant="outlined"
                            sx={{
                              backgroundColor: `hsl(355, 98%, 29%)`,
                              border: "none",
                            }}
                          >
                            <CardHeader
                              className="pb-0 my-0 mx-1"
                              style={{ padding: "0px" }}
                              avatar={
                                <span className={`font-weight-bold text-white`}>
                                  <InfoIcon />
                                </span>
                              }
                              title={
                                <>
                                  <strong className="text-white  mt-0">
                                    The employee's response to the requested
                                    explanation was due on{" "}
                                    {moment(
                                      caseRequest?.request
                                        ?.currentLetterSignedOn || null
                                    ).format("lll")}{" "}
                                    and is now overdue.
                                  </strong>
                                </>
                              }
                            />
                          </Card>
                        )} */}

                      {!!caseLetters.length && (
                        <>
                          {caseLetters.map((pendingLetter, index) => (
                            <ViewAdministrativeLetterCard
                              key={index}
                              pendingLetter={pendingLetter}
                              caseRequest={caseRequest}
                              hasPermissions={hasPermissions}
                              signLetter={signLetter}
                              onInitiateExplanationFeedbackLetter={
                                onInitiateExplanationFeedbackLetter
                              }
                              onInitiateProvisionalSuspensionLetter={
                                onInitiateProvisionalSuspensionLetter
                              }
                              onViewLetter={onViewLetter}
                              canProvideFeedback={
                                (+caseRequest?.request?.currentLetterTypeId ===
                                  5 &&
                                  +caseRequest?.request
                                    ?.currentLetterStatusId === 2) ||
                                (+caseRequest?.request?.currentLetterTypeId ===
                                  1 &&
                                  +caseRequest?.request
                                    ?.currentLetterStatusId === 2 &&
                                  !!caseRequest?.request
                                    ?.isEmployeeDelayedToRespond)
                              }
                              canProvideProvisionalSuspension={
                                caseRequest.request.decisionLevel === 2 &&
                                caseRequest.request
                                  .doesProvisionalSuspensionInitiated === 0 &&
                                ((+caseRequest?.request?.currentLetterTypeId ===
                                  5 &&
                                  +caseRequest?.request
                                    ?.currentLetterStatusId === 2) ||
                                  (+caseRequest?.request
                                    ?.currentLetterTypeId === 1 &&
                                    +caseRequest?.request
                                      ?.currentLetterStatusId === 2 &&
                                    !!caseRequest?.request
                                      ?.isEmployeeDelayedToRespond) ||
                                  (+caseRequest?.request
                                    ?.currentLetterTypeId === 6 &&
                                    +caseRequest?.request
                                      ?.currentLetterStatusId === 2 &&
                                    !!caseRequest?.request
                                      ?.isEmployeeDelayedToRespond))
                              }
                              onClose={onClose}
                            />
                          ))}
                        </>
                      )}
                    </div>
                  </div>

                  <div className="card service-card valid mb-2 mt-3">
                    <div
                      className="card-header  d-flex justify-content-between align-items-center"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      II. Faults
                      {isEditable && (
                        <IconButton
                          size="small"
                          edge="end"
                          color="primary"
                          onClick={() => {
                            setShowAddFaultForm(true);
                          }}
                        >
                          <span className="material-icons">add</span>
                        </IconButton>
                      )}
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <table className="table-striped table-hover table-sm  fixTableHead">
                            <thead>
                              <tr style={{ backgroundColor: "#f0f2f5" }}>
                                <th scope="col" className="text-left">
                                  Fault
                                </th>

                                <th scope="col" className="text-left">
                                  Category
                                </th>

                                <th scope="col" className="text-left">
                                  Sanction
                                </th>
                                {isEditable && (
                                  <th scope="col" className="text-right">
                                    <span className="mr-3">Actions</span>
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {caseRequest?.faults.map((fault, index) => (
                                <tr key={index}>
                                  <td className="text-left">
                                    <strong> {fault.faultName} </strong>
                                  </td>
                                  <td>{fault.faultCategoryName} Level</td>
                                  <td>{fault.faultSanctionName}</td>
                                  {isEditable && (
                                    <td className="text-right">
                                      <IconButton
                                        size="small"
                                        edge="end"
                                        color="error"
                                        onClick={() => {
                                          setShowFault(fault);
                                          setShowRemoveFaultForm(true);
                                        }}
                                      >
                                        <span className="material-icons">
                                          delete
                                        </span>
                                      </IconButton>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card service-card valid mb-2 mt-3">
                    <div
                      className="card-header"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      III. Case Description
                    </div>
                    <div className="card-body">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ marginTop: "-5px" }}
                      >
                        {caseDescription}
                        {isEditable && (
                          <Button variant="outlined" size="small">
                            <IconButton
                              size="small"
                              edge="end"
                              color="primary"
                              onClick={() => {
                                setShowCaseDescForm(true);
                              }}
                            >
                              <span className="material-icons">edit</span>
                            </IconButton>
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  {reportCommitteeSummary && (
                    <div className="card service-card valid mb-2 mt-3">
                      <div
                        className="card-header"
                        style={{ padding: "0.25rem 1.2rem" }}
                      >
                        IV. Internal disciplinary committee (IDC) report
                      </div>
                      <div className="card-body">
                        <fieldset className="form-group border p-2">
                          <legend
                            className="w-auto px-2"
                            style={{
                              color: "rgba(0, 0, 0, 0.6)",
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              // lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            Effected Date
                          </legend>
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginTop: "-5px" }}
                          >
                            {reportCommitteeDate
                              ? moment(
                                  caseRequest?.request?.reportCommitteeDate ||
                                    null,
                                ).format("ll")
                              : "N/A"}
                          </div>
                        </fieldset>
                        <fieldset className="form-group border p-2">
                          <legend
                            className="w-auto px-2"
                            style={{
                              color: "rgba(0, 0, 0, 0.6)",
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              // lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            Summary of the conclusions of the committee
                          </legend>
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginTop: "-5px" }}
                          >
                            {reportCommitteeSummary || "N/A"}
                          </div>
                        </fieldset>
                        <ViewCaseAttachments
                          viewIDCReport={true}
                          caseId={caseRequest?.request?.id}
                        />
                      </div>
                    </div>
                  )}

                  {caseRequest?.request?.caseSanctionName && (
                    <div className="card service-card valid mb-2 mt-3">
                      <div
                        className="card-header"
                        style={{ padding: "0.25rem 1.2rem" }}
                      >
                        V. Case Sanction Details
                      </div>
                      <div className="card-body">
                        <table className="table-striped table-hover table-sm  fixTableHead mt-0">
                          <tr style={{ backgroundColor: "#f0f2f5" }}>
                            <th scope="col" className="text-left">
                              Sanction:
                            </th>
                            <td>
                              {caseRequest?.request?.caseSanctionName || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "#f0f2f5" }}>
                            <th scope="col" className="text-left">
                              EffectedFrom:
                            </th>
                            <td>
                              {caseRequest?.request?.sanctionEffectedFrom
                                ? moment(
                                    caseRequest?.request?.sanctionEffectedFrom,
                                  ).format("ll")
                                : "N/A"}
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "#f0f2f5" }}>
                            <th scope="col" className="text-left">
                              EffectedTo:
                            </th>
                            <td>
                              {caseRequest?.request?.sanctionEffectedTo
                                ? moment(
                                    caseRequest?.request?.sanctionEffectedTo,
                                  ).format("ll")
                                : "N/A"}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  )}
                  {caseRequest?.request?.provSuspensionEffectedFrom && (
                    <div className="card service-card valid mb-2 mt-3">
                      <div
                        className="card-header"
                        style={{ padding: "0.25rem 1.2rem" }}
                      >
                        VI. Provisional Suspension Details
                      </div>
                      <div className="card-body">
                        <table className="table-striped table-hover table-sm  fixTableHead mt-0">
                          <tr style={{ backgroundColor: "#f0f2f5" }}>
                            <th scope="col" className="text-left">
                              EffectedFrom:
                            </th>
                            <td>
                              {caseRequest?.request?.provSuspensionEffectedFrom
                                ? moment(
                                    caseRequest?.request
                                      ?.provSuspensionEffectedFrom,
                                  ).format("ll")
                                : "N/A"}
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "#f0f2f5" }}>
                            <th scope="col" className="text-left">
                              EffectedTo:
                            </th>
                            <td>
                              {caseRequest?.request?.provSuspensionEffectedTo
                                ? moment(
                                    caseRequest?.request
                                      ?.provSuspensionEffectedTo,
                                  ).format("ll")
                                : "N/A"}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  )}
                </Typography>
              </React.Fragment>

              <ViewCaseAttachments
                viewIDCReport={false}
                caseId={caseRequest?.request?.id}
                canEdit={isEditable}
              />
            </Box>
          )}

          {tabValue === 1 && (
            <Box sx={{ width: "100%", minHeight: "80vh" }} className="mt-1">
              <React.Fragment>
                <Typography component={"div"} sx={{ mt: 0, mb: 1 }}>
                  <ViewCaseLogs caseId={caseRequest?.request?.id} />
                </Typography>
              </React.Fragment>
            </Box>
          )}
        </DialogContent>
        <DialogActions className="py-3 mx-0 d-flex justify-content-center">
          {showCommitteeReportForm && (
            <CommitteeReportFormDialog
              caseRequest={caseRequest}
              setShowCommitteeReportForm={setShowCommitteeReportForm}
              showCommitteeReportForm={showCommitteeReportForm}
            />
          )}

          {showCloseCaseDialog && (
            <ConfirmationDialog
              confirmationDialog={showCloseCaseDialog}
              disabled={!reason}
              message={
                <>
                  {" "}
                  Are you sure you want to{" "}
                  <strong className="text-danger">close</strong> the case for{" "}
                  <span className="contact_span">
                    <span className="ml-1">
                      {textCapitalized(caseRequest?.request?.lastName)}{" "}
                      {textCapitalized(caseRequest?.request?.firstName)}
                    </span>
                  </span>
                  <div>
                    <TextField
                      fullWidth
                      size="small"
                      multiline
                      rows={4}
                      name="reason"
                      label="Reason .."
                      variant="outlined"
                      placeholder="Reason .."
                      value={reason}
                      onChange={(e) => {
                        setReason(e.target.value || "");
                      }}
                    />
                  </div>
                </>
              }
              setConfirmationDialog={setShowCloseCaseDialog}
              onYes={() => {
                closeCaseRequest(caseRequest?.request.id, reason, onClose);
              }}
            />
          )}
        </DialogActions>
        {showAddFaultForm && (
          <ConfirmationDialog
            disabled={!tmpFaults.length}
            confirmationDialog={showAddFaultForm}
            size="lg"
            title="Add Fault"
            message={
              <>
                <div style={{ width: "400px" }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    multiple
                    id="tmpFaults"
                    className="w-100"
                    options={filteredFaults.map(
                      ({ faultName, sanction, id }) => ({
                        faultName,
                        sanction,
                        id,
                      }),
                    )}
                    value={tmpFaults}
                    onChange={(e, fault) => {
                      const uniqueFaults = removeDuplicates(fault);
                      setTmpFaults(uniqueFaults);
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.faultName}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} className="w-100">
                        <div className="row w-100">
                          <div className="col-10">
                            <Checkbox
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              checked={
                                selected ||
                                !!tmpFaults.find(({ id }) => id === option.id)
                              }
                            />
                            {option.faultName}{" "}
                          </div>
                          <div className="col-2">
                            <span className="badge badge-primary text-right float-right">
                              {option.sanction}
                            </span>
                          </div>
                        </div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        width="w-100"
                        {...params}
                        label={"Select the employee faults"}
                        placeholder={"Select the employee faults"}
                      />
                    )}
                  />
                </div>
              </>
            }
            setConfirmationDialog={setShowAddFaultForm}
            onYes={() => {
              updateCaseFault(
                {
                  caseId: caseRequest?.request?.id,
                  faults: tmpFaults,
                },
                caseRequest,
                setShowAddFaultForm,
                setTmpFaults,
              );
            }}
          />
        )}
        {showRemoveFaultForm && (
          <ConfirmationDialog
            confirmationDialog={showRemoveFaultForm}
            message={
              <>
                <p>
                  Are you sure you want to{" "}
                  <strong className="text-danger">remove</strong> this fault @
                  {showFault.faultName}?
                </p>
              </>
            }
            setConfirmationDialog={setShowRemoveFaultForm}
            onYes={() => {
              removeCaseFault(
                {
                  caseFaultId: showFault.id,
                },
                caseRequest,
                setShowRemoveFaultForm,
              );
            }}
          />
        )}
        {showCaseDescForm && (
          <ConfirmationDialog
            confirmationDialog={showCaseDescForm}
            disabled={!caseDescription}
            size="lg"
            message={
              <>
                {" "}
                <div style={{ width: "300px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    name="caseDescription"
                    label="Case Description .."
                    variant="outlined"
                    placeholder="Case Description .."
                    value={caseDescription}
                    onChange={(e) => {
                      setCaseDescription(e.target.value || "");
                    }}
                  />
                </div>
              </>
            }
            setConfirmationDialog={setShowCaseDescForm}
            onYes={() => {
              updateCaseDesc(
                {
                  caseId: caseRequest?.request?.id,
                  caseDescription: caseDescription,
                },
                caseRequest,
                setShowCaseDescForm,
              );
            }}
          />
        )}
        {showCaseReportCommitteeSummaryForm && (
          <ConfirmationDialog
            confirmationDialog={showCaseReportCommitteeSummaryForm}
            disabled={!reportCommitteeSummary}
            size="lg"
            message={
              <>
                {" "}
                <div style={{ width: "300px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    name="reportCommitteeSummary"
                    label="Please specify the summary of the committee's conclusions. "
                    variant="outlined"
                    placeholder="Please specify the summary of the committee's conclusions. .."
                    value={reportCommitteeSummary}
                    onChange={(e) => {
                      setReportCommitteeSummary(e.target.value || "");
                    }}
                  />
                </div>
              </>
            }
            setConfirmationDialog={setShowCaseReportCommitteeSummaryForm}
            onYes={() => {
              updateCaseIDCReport(
                {
                  caseId: caseRequest?.request?.id,
                  key: "reportCommitteeSummary",
                  value: reportCommitteeSummary,
                },
                caseRequest,
                setShowCaseReportCommitteeSummaryForm,
              );
            }}
          />
        )}
        {showCaseReportCommitteeDateForm && (
          <ConfirmationDialog
            confirmationDialog={showCaseReportCommitteeDateForm}
            disabled={!reportCommitteeDate}
            size="lg"
            message={
              <>
                {" "}
                <div style={{ width: "300px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Please specify the date of the Internal Disciplinary Committee's approved report."
                      inputFormat="dd/MM/yyyy"
                      disabled={!reportCommitteeDate}
                      value={reportCommitteeDate}
                      onChange={(date) => {
                        setReportCommitteeDate(date || null);
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          required={true}
                          fullWidth
                          size="small"
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </>
            }
            setConfirmationDialog={setShowCaseReportCommitteeDateForm}
            onYes={() => {
              updateCaseIDCReport(
                {
                  caseId: caseRequest?.request?.id,
                  key: "reportCommitteeDate",
                  value: reportCommitteeDate,
                },
                caseRequest,
                setShowCaseReportCommitteeDateForm,
              );
            }}
          />
        )}

        <Dialog
          open={showAppointingAuthorityEditDialog}
          onClose={() => setShowAppointingAuthorityEditDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="text-primary">
            Update appointing authority
          </DialogTitle>
          <DialogContent dividers>
            <Autocomplete
              fullWidth
              size="small"
              className="mt-1"
              loading={loadingPlanningEntities}
              value={selectedAppointingAuthorityPlanningEntity}
              options={uniquePlanningEntities}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, row) => {
                setSelectedAppointingAuthorityPlanningEntity(row || null);
              }}
              getOptionLabel={(option) =>
                option?.name
                  ? `${option.name}${
                      option.entitySector?.sector?.name
                        ? ` / ${option.entitySector.sector.name}`
                        : ""
                    }`
                  : ""
              }
              renderOption={(props, row) => {
                const { key: _muiKey, ...optionProps } = props;
                return (
                  <Box
                    component="li"
                    {...optionProps}
                    key={row?.id ?? `option-${_muiKey}`}
                  >
                    {row.name}
                    {row.entitySector?.sector ? (
                      <span className="ml-2 badge badge-primary">
                        {row.entitySector.sector.name}
                      </span>
                    ) : null}
                  </Box>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Appointing authority institution"
                  placeholder="Search and select institution"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "appointingAuthorityPlanningEntityId",
                  }}
                />
              )}
            />
            <Alert severity="info" className="mt-3" icon={false}>
              <AlertTitle>Note</AlertTitle>
              Select the institution that acts as appointing authority for this
              case. Save applies your choice to this disciplinary case.
            </Alert>
          </DialogContent>
          <DialogActions className="px-3 pb-3">
            <Button onClick={() => setShowAppointingAuthorityEditDialog(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={
                !selectedAppointingAuthorityPlanningEntity ||
                loadingPlanningEntities
              }
              onClick={() => {
                updateCaseAppointingAuthority(
                  {
                    caseId: caseRequest?.request?.id,
                    appointingAuthorityPlanningEntityId:
                      selectedAppointingAuthorityPlanningEntity?.id,
                  },
                  caseRequest,
                  () => setShowAppointingAuthorityEditDialog(false),
                );
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {showSendToAppointingAuthorityConfirm && (
          <ConfirmationDialog
            confirmationDialog={showSendToAppointingAuthorityConfirm}
            setConfirmationDialog={setShowSendToAppointingAuthorityConfirm}
            title="Send to Appointing Authority"
            noPreFormat
            fullWidth
            size="sm"
            alignContent="left"
            message={
              <Box>
                <Typography variant="body2" className="text-left py-1">
                  Select the appointing authority, then send this case to them
                  for their attention.
                </Typography>
                <Autocomplete
                  fullWidth
                  size="small"
                  className="mt-2 mb-2"
                  loading={loadingSendToAaOptions}
                  value={selectedForSendToAppointingAuthority}
                  options={uniquePlanningEntities}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(_e, row) => {
                    setSelectedForSendToAppointingAuthority(row || null);
                  }}
                  getOptionLabel={(option) =>
                    option?.name
                      ? `${option.name}${
                          option.entitySector?.sector?.name
                            ? ` / ${option.entitySector.sector.name}`
                            : ""
                        }`
                      : ""
                  }
                  renderOption={(props, row) => {
                    const { key: _muiKey, ...optionProps } = props;
                    return (
                      <Box
                        component="li"
                        {...optionProps}
                        key={row?.id ?? `opt-${_muiKey}`}
                      >
                        {row.name}
                        {row.entitySector?.sector ? (
                          <span className="ml-2 badge badge-primary">
                            {row.entitySector.sector.name}
                          </span>
                        ) : null}
                      </Box>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Appointing authority"
                      placeholder="Search and select institution"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "off",
                      }}
                    />
                  )}
                />
              </Box>
            }
            disabled={
              !selectedForSendToAppointingAuthority?.id ||
              loadingSendToAaOptions
            }
            btnMessage="Send"
            onYes={() => {
              if (!selectedForSendToAppointingAuthority?.id) return;
              notifyCaseAppointingAuthority(
                caseRequest?.request?.id,
                selectedForSendToAppointingAuthority.id,
                caseRequest,
                () => setShowSendToAppointingAuthorityConfirm(false),
              );
            }}
          />
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  caseRequest,
  headOfInstitution,
  faults,
  caseLetters,
  allPlanningEntities,
}) => {
  return {
    user,
    loading,
    caseRequest,
    headOfInstitution,
    faults,
    caseLetters,
    allPlanningEntities,
  };
};
export default connect(mapStateToProps, {
  getHeadOfInstitution,
  getUserDetails,
  getFaultWithSanction,
  updateCaseFault,
  removeCaseFault,
  updateCaseDesc,
  updateCaseIDCReport,
  closeCaseRequest,
  getCaseLetters,
  signLetter,
  suspendEmployeeProvisionally,
  onInitiateExplanationFeedbackLetter,
  onInitiateProvisionalSuspensionLetter,
  onViewLetter,
  onInitiateSanctionLetter,
  getAllPlanningEntities,
  updateCaseAppointingAuthority,
  notifyCaseAppointingAuthority,
})(ViewCaseDialog);

const ViewAdministrativeLetterCard = (props) => {
  const {
    pendingLetter,
    caseRequest,
    hasPermissions,
    onInitiateExplanationFeedbackLetter,
    onViewLetter,
    onClose,
    canProvideFeedback,
    canProvideProvisionalSuspension,
    onInitiateProvisionalSuspensionLetter,
    signLetter,
  } = props;

  const [showLetter, setShowLetter] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [onViewDocument, setOnViewDocument] = useState(false);
  const [enableToFillLetter, setEnableToFillLetter] = useState(false);
  const [showCaseApproverForm, setShowCaseApproverForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pkiPassword, setPkiPassword] = useState("");
  const [formData, setFormData] = useState({
    id: pendingLetter?.id,
    caseId: pendingLetter?.caseId,
    letterBodyContent: pendingLetter?.letterBodyContent,
    ccInstitutionNames: pendingLetter?.ccInstitutionNames,
  });
  const isAllowed =
    (caseRequest?.request?.approverPlanningEntityId ===
      caseRequest?.request?.planningEntityId &&
      !caseRequest?.request?.isSentToAppointingAuthority) ||
    (caseRequest?.request?.appointingAuthorityPlanningEntityId ===
      caseRequest?.request?.approverPlanningEntityId &&
      caseRequest?.request?.isSentToAppointingAuthority);
// console.log(caseRequest?.request);

// isSentToAppointingAuthority: false
// approverPlanningEntityId: "7400000000-090000000000000000"
// appointingAuthorityPlanningEntityId: null
// planningEntityId: "7400000000-090000000000000000"

  const viewLetter = () => {
    if (!pendingLetter?.letterViewedOn) {
      onViewLetter(pendingLetter?.id, (isLoading, data) => {
        setIsLoading1(isLoading);
        if (data) {
          pendingLetter.letterViewedOn = data;
          setSelectedLetter(pendingLetter);
          setOnViewDocument(true);
        }
      });
    } else {
      setSelectedLetter(pendingLetter);
      setOnViewDocument(true);
    }
  };
  /** Signed letter: open PDF. Draft (no file yet): open ViewLetterDialog read-only. */
  const openViewLetter = () => {
    if (pendingLetter?.docReferenceId) {
      viewLetter();
    } else {
      setSelectedLetter(pendingLetter);
      setEnableToFillLetter(false);
      setShowLetter(true);
    }
  };
  // console.log(caseRequest?.request);
  return (
    <>
      <div className="d-flex justify-content-center w-100 mt-1">
        <Card
          className={`mb-2 w-100 rounded hoverable-card card border-${
            pendingLetter?.letterStatusId === 1
              ? "primary"
              : pendingLetter?.letterStatusId === 2
                ? "success"
                : pendingLetter?.letterStatusId === 4
                  ? "warning"
                  : "danger"
          }`}
          elevation={1}
          variant="elevation"
          style={{
            backgroundColor: "#fff",
          }}
        >
          <CardHeader
            avatar={
              <>
                {pendingLetter?.docReferenceId ? (
                  <>
                    <span className={`font-weight-bold text-success`}>
                      <FilePresentIcon
                        // fontSize="large"
                        style={{
                          color: !!pendingLetter?.docReferenceId
                            ? "#fe4066"
                            : "#c57c7cb8",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={viewLetter}
                      />
                    </span>
                  </>
                ) : (
                  <>
                    <span className={`font-weight-bold text-primary`}>
                      <TextSnippetIcon />
                    </span>
                  </>
                )}
              </>
            }
            title={
              <Typography>
                <strong>
                  {!!pendingLetter && (
                    <>
                      {!!pendingLetter?.docReferenceId ? (
                        <>
                          <span
                            className="text-primary"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={viewLetter}
                          >
                            {pendingLetter?.letterDesc || ""}
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="text-primary">
                            {pendingLetter?.letterDesc || ""}
                          </span>
                        </>
                      )}
                      <span
                        className={`badge ml-1 bg-${
                          pendingLetter?.letterStatusId === 1
                            ? "primary"
                            : pendingLetter?.letterStatusId === 2
                              ? "success"
                              : pendingLetter?.letterStatusId === 4
                                ? "warning"
                                : "danger"
                        } text-white px-2`}
                      >
                        {pendingLetter?.letterStatusName}
                      </span>{" "}
                      <br />
                      <small className="badge badge-pill text-dark px-0">
                        {" "}
                        #{pendingLetter?.letterNo || ""}
                      </small>
                      <br />
                      {isAllowed && (
                        <Tooltip
                          title={
                            pendingLetter?.docReferenceId
                              ? "Open the generated letter (PDF). View only."
                              : "Open the letter draft. View only — not editable from here."
                          }
                        >
                          <span>
                            <Button
                              type="button"
                              size="small"
                              variant="text"
                              className="p-0 mt-1"
                              sx={{ textTransform: "none", minWidth: 0 }}
                              onClick={openViewLetter}
                              disabled={isLoading1}
                            >
                              {isLoading1 ? "Please wait…" : "View letter"}
                            </Button>
                          </span>
                        </Tooltip>
                      )}
                    </>
                  )}
                </strong>
              </Typography>
            }
            action={
              <>
                <div
                  className="d-flex flex-row align-items-center pull-right"
                  style={{ borderRadius: "4px" }}
                >
                  {/* WHEN HR TRYING TO RESUME LETTER FOR REQUESTING EXPLANATION AT LEVEL 2 */}
                  <ActionButton
                    condition={
                      [2].includes(caseRequest?.request?.decisionLevel) &&
                      [1].includes(pendingLetter?.letterTypeId) &&
                      pendingLetter?.letterStatusId === 1 &&
                      hasPermissions(["IS_HR"]) &&
                      isAllowed
                    }
                    disabled={caseRequest?.request?.caseStatusId === 2}
                    variant="contained"
                    color="primary"
                    className="mx-1"
                    text={pendingLetter?.isReviewed ? "View" : "Resume"}
                    icon="next_plan"
                    onClick={() => {
                      setShowLetter(true);
                      setSelectedLetter(pendingLetter);
                      setEnableToFillLetter(
                        !pendingLetter?.isReviewed ? true : false,
                      );
                    }}
                  />
                  <ActionButton
                    condition={
                      [2].includes(caseRequest?.request?.decisionLevel) &&
                      [1].includes(pendingLetter?.letterTypeId) &&
                      pendingLetter?.letterStatusId === 1 &&
                      hasPermissions(["IS_SANCTION_INITIATOR"]) &&
                      isAllowed
                    }
                    disabled={caseRequest?.request?.caseStatusId === 2}
                    variant="contained"
                    color="primary"
                    className="mx-1"
                    text={pendingLetter?.isReviewed ? "Re-update" : "Review"}
                    icon="next_plan"
                    onClick={() => {
                      setShowLetter(true);
                      setSelectedLetter(pendingLetter);
                      setEnableToFillLetter(true);
                    }}
                  />

                  {/* WHEN SANCTION_INITIATOR TRYING TO RESUME SANCTION LETTER */}
                  <ActionButton
                    condition={
                      [1, 2].includes(caseRequest?.request?.decisionLevel) &&
                      [2, 3, 4, 6, 7, 8].includes(
                        pendingLetter?.letterTypeId,
                      ) &&
                      pendingLetter?.letterStatusId === 1 &&
                      hasPermissions(["IS_SANCTION_INITIATOR"]) &&
                      isAllowed
                    }
                    disabled={caseRequest?.request?.caseStatusId === 2}
                    variant="contained"
                    color="primary"
                    className="mx-1"
                    text="Resume"
                    icon="next_plan"
                    onClick={() => {
                      setShowLetter(true);
                      setSelectedLetter(pendingLetter);
                      setEnableToFillLetter(true);
                    }}
                  />
                  {/* WHEN YOU ARE HEAD OF UNIT OR HEAD OF INSTITUTION TRYING TO SIGN FEEDBACK LETTER */}
                  <ActionButton
                    condition={
                      ((caseRequest.request.decisionLevel === 1 &&
                        [6].includes(pendingLetter?.letterTypeId) &&
                        hasPermissions(["IS_HEAD_OF_UNIT"])) ||
                        (caseRequest.request.decisionLevel === 2 &&
                          [6].includes(pendingLetter?.letterTypeId) &&
                          hasPermissions([
                            "IS_HEAD_OF_INSTITUTION",
                            "IS_HEAD_OF_INSTITUTION_ACTING",
                          ]))) &&
                      pendingLetter?.letterStatusId === 1 &&
                      isAllowed
                    }
                    disabled={
                      caseRequest.request.caseStatusId === 2 ||
                      caseRequest.request.doesProvisionalSuspensionInitiated ===
                        1
                    }
                    variant="contained"
                    color="success"
                    className="mx-1"
                    text={`${
                      hasPermissions([
                        "IS_HEAD_OF_INSTITUTION",
                        "IS_HEAD_OF_INSTITUTION_ACTING",
                      ])
                        ? "Continue to Sign"
                        : "Resume"
                    }`}
                    icon="next_plan"
                    onClick={() => {
                      setShowLetter(true);
                      setSelectedLetter(pendingLetter);
                      setEnableToFillLetter(true);
                    }}
                  />

                  {/* WHEN YOU ARE HEAD OF HEAD OF INSTITUTION TRYING TO SIGN LETTER */}
                  <ActionButton
                    condition={
                      [1, 2].includes(caseRequest.request.decisionLevel) &&
                      [1, 2, 3, 4, 7, 8].includes(
                        pendingLetter?.letterTypeId,
                      ) &&
                      hasPermissions([
                        "IS_HEAD_OF_INSTITUTION",
                        "IS_HEAD_OF_INSTITUTION_ACTING",
                      ]) &&
                      pendingLetter?.letterStatusId === 1 &&
                      isAllowed
                    }
                    disabled={caseRequest.request.caseStatusId === 2}
                    variant="contained"
                    color="success"
                    className="mx-1"
                    text="Continue to Sign"
                    icon="next_plan"
                    onClick={() => {
                      setShowLetter(true);
                      setSelectedLetter(pendingLetter);
                      setEnableToFillLetter(true);
                    }}
                  />
                  {/* WHEN HEAD OF UNIT OR INSTITUTION TRYING TO PROVIDING FEEDBACK */}
                  {canProvideProvisionalSuspension &&
                    caseRequest?.request?.currentLetterTypeId ===
                      pendingLetter?.letterTypeId &&
                    hasPermissions([
                      "IS_HEAD_OF_INSTITUTION",
                      "IS_HEAD_OF_INSTITUTION_ACTING",
                      "IS_SANCTION_INITIATOR",
                    ]) &&
                    isAllowed && (
                      <ProvisionalSuspensionButton
                        pendingLetter={pendingLetter}
                        caseRequest={caseRequest}
                        isLoading={isLoading}
                        onCallback={(res, handleClose) => {
                          onInitiateProvisionalSuspensionLetter(
                            {
                              caseId: caseRequest?.request?.id,
                              ...res,
                            },
                            caseRequest,
                            (isLoading, data) => {
                              setIsLoading(isLoading);
                              // console.log(data);
                              if (data) {
                                setFormData({
                                  id: data?.id,
                                  caseId: data?.caseId,
                                  letterBodyContent: data?.letterBodyContent,
                                  ccInstitutionNames: data?.ccInstitutionNames,
                                });
                                setSelectedLetter(data);
                                setShowLetter(true);
                                setEnableToFillLetter(true);
                                handleClose();
                              }
                            },
                          );
                        }}
                      />
                    )}

                  {/* WHEN HEAD OF UNIT OR INSTITUTION TRYING TO PROVIDING FEEDBACK */}
                  {canProvideFeedback &&
                    caseRequest?.request?.currentLetterTypeId ===
                      pendingLetter?.letterTypeId &&
                    ((caseRequest.request.decisionLevel === 1 &&
                      hasPermissions(["IS_HEAD_OF_UNIT"])) ||
                      (caseRequest.request.decisionLevel === 2 &&
                        hasPermissions([
                          // "IS_HEAD_OF_INSTITUTION",
                          // "IS_HEAD_OF_INSTITUTION_ACTING",
                          "IS_SANCTION_INITIATOR",
                        ]))) &&
                    isAllowed && (
                      <ProvideFeedbackLetterButton
                        pendingLetter={pendingLetter}
                        caseRequest={caseRequest}
                        isLoading={isLoading}
                        onCallback={(res, handleClose) => {
                          onInitiateExplanationFeedbackLetter(
                            {
                              caseId: caseRequest?.request?.id,
                              ...res,
                            },
                            caseRequest,
                            (isLoading, data) => {
                              setIsLoading(isLoading);
                              // console.log(data);
                              if (data) {
                                setFormData({
                                  id: data?.id,
                                  caseId: data?.caseId,
                                  letterBodyContent: data?.letterBodyContent,
                                  ccInstitutionNames: data?.ccInstitutionNames,
                                });
                                setSelectedLetter(data);
                                setShowLetter(true);
                                setEnableToFillLetter(true);
                                handleClose();
                              }
                            },
                          );
                        }}
                      />
                    )}

                  {/* ON VIEW LETTER */}
                  <ActionButton
                    condition={pendingLetter?.docReferenceId}
                    variant="outlined"
                    color="success"
                    className="mx-1"
                    endIcon={<OpenInNewIcon />}
                    text={isLoading1 ? "Wait...." : "View Letter"}
                    onClick={viewLetter}
                  />
                </div>
              </>
            }
          />
        </Card>

        {onViewDocument && selectedLetter && (
          <PreviewPdfUrl
            showDocument={onViewDocument}
            setShowDocument={setOnViewDocument}
            document={{
              name: `${selectedLetter?.letterDesc || ""}`,
              url:
                process.env.REACT_APP_FILES_URL +
                "/preview/" +
                selectedLetter?.docReferenceId,
            }}
          />
        )}
        {showLetter && selectedLetter && caseRequest && (
          <ViewLetterDialog
            showLetter={showLetter}
            selectedLetter={selectedLetter}
            setShowLetter={setShowLetter}
            setEnableToFillLetter={setEnableToFillLetter}
            employee={{
              lastName: caseRequest?.request?.lastName,
              firstName: caseRequest?.request?.firstName,
              phoneNumber: caseRequest?.request?.phoneNumber,
              email: caseRequest?.request?.email,
              entityName: caseRequest?.request?.entityName,
              entitySectorId: caseRequest?.request?.entitySectorId,
              appointingAuthorityPlanningEntityId:
                caseRequest?.request?.appointingAuthorityPlanningEntityId ||
                null,
              planningEntityId: caseRequest?.request?.planningEntityId || null,
            }}
            decisionLevel={caseRequest?.request?.decisionLevel}
            onUpdateLetter={(formData) => {
              setFormData({ ...formData });
            }}
            action={
              <>
                {((caseRequest.request.decisionLevel === 1 &&
                  [6].includes(pendingLetter?.letterTypeId) &&
                  pendingLetter?.letterStatusId === 1 &&
                  hasPermissions(["IS_HEAD_OF_UNIT"])) ||
                  ([1, 2].includes(caseRequest.request.decisionLevel) &&
                    [1, 2, 3, 4, 6, 7, 8].includes(
                      pendingLetter?.letterTypeId,
                    ) &&
                    pendingLetter?.letterStatusId === 1 &&
                    hasPermissions([
                      "IS_HEAD_OF_INSTITUTION",
                      "IS_HEAD_OF_INSTITUTION_ACTING",
                    ]))) && (
                  <>
                    {!enableToFillLetter && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          className="mx-1"
                          size="small"
                          startIcon={
                            <span className="material-icons-outlined">
                              draw
                            </span>
                          }
                          onClick={() => {
                            setShowCaseApproverForm(true);
                          }}
                        >
                          SIGN
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="float-right mx-1 my-1"
                          startIcon={
                            <span className="material-icons-outlined">
                              edit
                            </span>
                          }
                          onClick={() => {
                            setEnableToFillLetter(true);
                          }}
                        >
                          Edit
                        </Button>
                      </>
                    )}
                  </>
                )}
              </>
            }
            enableToFillLetter={enableToFillLetter}
          />
        )}

        {showCaseApproverForm && (
          <ConfirmationDialog
            disabled={!pkiPassword}
            confirmationDialog={showCaseApproverForm}
            message={
              <>
                <p className="px-4">
                  <SignLetter />
                </p>
                <p>Enter your RISA Digital signature password to sign</p>
                <form>
                  <TextField
                    fullWidth
                    size="small"
                    id="pki-password"
                    rows={4}
                    name="pki-password"
                    type="password"
                    label="Enter your RISA Digital signature password to sign"
                    variant="outlined"
                    placeholder="Enter your RISA Digital signature password to sign"
                    value={pkiPassword}
                    onChange={(e) => {
                      setPkiPassword(e.target.value || "");
                    }}
                  />
                </form>
              </>
            }
            setConfirmationDialog={setShowCaseApproverForm}
            onYes={() => {
              formData.password = pkiPassword;
              formData.caseId = caseRequest?.request?.id;
              formData.letterId = selectedLetter.id;

              signLetter(formData, onClose);
            }}
          />
        )}
      </div>
    </>
  );
};

const ProvideFeedbackLetterButton = (props) => {
  const { pendingLetter, caseRequest, onCallback, isLoading } = props;

  const [currentSelectedFeedBack, setCurrentSelectedFeedBack] = useState(null);
  const [proposedSanction, setProposedSanction] = useState("");
  // console.log(pendingLetter, caseRequest.request);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  useEffect(() => {
    let faults = [
      ...new Map(
        caseRequest?.faults.map((item) => [item.faultSanctionId, item]),
      ).values(),
    ];
    const formattedFaults = faults.map((fault) => fault.faultSanctionName);
    const proposedSanction =
      formattedFaults.length > 1
        ? formattedFaults.slice(0, -1).join(", ") +
          ", or " +
          formattedFaults.slice(-1)
        : formattedFaults[0] || "";
    setProposedSanction(proposedSanction);
  }, [caseRequest]);
  const handleGiveSanction = (event) => {
    // setCurrentSelectedFeedBack(null);

    if (
      !pendingLetter?.letterViewedOn //&& (+pendingLetter?.letterTypeId === 5 && pendingLetter?.letterStatusId === 2)
    ) {
      showError(
        `You should first view the letter before providing your feedback.`,
      );
    } else {
      setAnchorEl(event.currentTarget);
      setAnchorPosition({ top: event.clientY, left: event.clientX }); // Capture mouse position
    }
  };
  // console.log(caseRequest?.request?.decisionLevel);
  const handleCloseGiveSanction = () => {
    setCurrentSelectedFeedBack(null);
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const didProvidedExplanation =
    +pendingLetter?.letterTypeId === 5 && pendingLetter?.letterStatusId === 2;
  const feedbackDecisions = [
    {
      key: "GIVE_SANCTION",
      title: "Impose the sanction",
      color: "primary",
      letterTemplate: didProvidedExplanation
        ? `I regret to inform you that, your explanation has been found unsatisfactory and unconvincing. Consequently, a sanction of  <span  style="font-weight:bold;font-family: Times New Roman;font-size: 16px;">[Kindly insert the proposed sanction here (e.g., ${proposedSanction}) based on the nature of the case]</span> will be imposed on you.`
        : `Noting that you did not provide any explanation, I regret to inform you that a sanction of <span style="font-weight:bold;font-family: Times New Roman;font-size: 16px;">[Kindly insert the proposed sanction here (e.g., ${proposedSanction}) based on the nature of the case]</span> will be imposed on you.`,
    },
    // caseRequest?.request?.decisionLevel === 2
    //   ?
    {
      key: "SUBMIT_TO_COMMITTEE",
      color: "warning",
      title: "Proceed to Disciplinary Committee",
      letterTemplate: didProvidedExplanation
        ? "<div>I regret to inform you that, your explanation has been found unsatisfactory and unconvincing. Therefore, your case has been submitted to the Internal Disciplinary Committee for further investigation and decision.</div>"
        : "<div>Noting that you did not provide any explanation. I regret to inform you that, your case has been submitted to the Internal Disciplinary Committee for further investigation and decision.</div>",
    },
    // : null,
    didProvidedExplanation
      ? {
          key: "CLOSE_CASE",
          color: "secondary",
          title: "Close the case",
          letterTemplate:
            "I am pleased to inform you that, your explanation has been found satisfactory and convincing. Therefore, the case is now closed, and no further action will be taken.",
        }
      : null, // If conditions are not met, don't add the item to the array
  ].filter((item) => item !== null); // Filter out any null values;

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        className="mx-1"
        size="small"
        startIcon={<AddIcon />}
        style={{ textTransform: "none" }}
        disabled={isLoading || caseRequest.request.caseStatusId === 2}
        aria-describedby={id}
        onClick={handleGiveSanction}
      >
        {isLoading
          ? "Wait...."
          : +pendingLetter?.letterTypeId === 5 &&
              pendingLetter?.letterStatusId === 2
            ? "Feedback"
            : "Take Decision"}
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseGiveSanction}
        anchorReference="anchorPosition" // Positioning based on mouse click
        anchorPosition={{ top: anchorPosition.top, left: anchorPosition.left }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Card sx={{ maxWidth: 600, minWidth: 400 }}>
          <CardHeader
            sx={true}
            action={
              <IconButton aria-label="close" onClick={handleCloseGiveSanction}>
                <span className="material-icons">close</span>
              </IconButton>
            }
            subheader="Take Feedback Decision"
          />
          <Divider />
          <CardContent>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue="female"
                name="radio-buttons-group"
              >
                {feedbackDecisions.map((feedback, index) => (
                  <FormControlLabel
                    disabled={isLoading}
                    key={feedback.key}
                    value={feedback.key}
                    control={<Radio disabled={isLoading} />}
                    label={feedback.title}
                    onChange={() => setCurrentSelectedFeedBack(feedback)}
                    checked={currentSelectedFeedBack?.key === feedback.key}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </CardContent>

          <CardActions
            disableSpacing
            className="py-3 d-flex justify-content-center"
          >
            <Button
              variant="contained"
              color="primary"
              disabled={!currentSelectedFeedBack || isLoading}
              onClick={() => {
                // setCurrentSelectedFeedBack(null);
                onCallback(
                  {
                    ...currentSelectedFeedBack,
                  },
                  handleCloseGiveSanction,
                );
              }}
            >
              {isLoading ? "Wait.." : "Next"}{" "}
            </Button>
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

const ProvisionalSuspensionButton = (props) => {
  const { pendingLetter, caseRequest, onCallback, isLoading } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const periods = [
    { id: 1, name: "1 month", days: 30 },
    { id: 2, name: "2 months", days: 60 },
    { id: 3, name: "3 months", days: 90 },
  ];
  const [period, setPeriod] = useState(null);

  const [errors, setErrors] = useState({
    hasError: false,
    effectedFromError: false,
    effectedToError: false,
    periodError: false,
    reasonHasError: false,
  });

  const handleOpened = (event) => {
    if (
      !pendingLetter?.letterViewedOn //&& (+pendingLetter?.letterTypeId === 5 && pendingLetter?.letterStatusId === 2)
    ) {
      showError(
        `You should first view the letter before providing your feedback.`,
      );
    } else {
      setAnchorEl(event.currentTarget);
      setAnchorPosition({ top: event.clientY, left: event.clientX }); // Capture mouse position
    }
  };

  const handleClosed = () => {
    setAnchorEl(null);
  };

  const [formData, setFormData] = useState({
    caseId: caseRequest?.request?.id || "",
    reason: "",
    sanctionId: "",
    effectedFrom: null,
    effectedTo: null,
    period: 0,
  });

  const formValidator = () => {
    const error = {
      hasError: false,
      periodError: false,
      effectedFromError: false,
      effectedToError: false,
      reasonHasError: false,
    };

    if (!formData.effectedFrom) {
      error.effectedFromError = true;
      error.hasError = true;
    }

    if (!formData.effectedTo) {
      error.effectedToError = true;
      error.hasError = true;
    }
    if (!formData.period) {
      error.periodError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill the required field");
      return true;
    }
    return false;
  };
  // console.log(currentSanction);
  return (
    <>
      <Button
        variant="contained"
        color="warning"
        aria-describedby={id}
        disabled={isLoading}
        onClick={handleOpened}
        style={{ marginRight: "10px", textTransform: "none" }}
        startIcon={<AddIcon />}
      >
        {isLoading ? "Wait...." : "Provisional suspension"}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosed}
        anchorReference="anchorPosition" // Positioning based on mouse click
        anchorPosition={{ top: anchorPosition.top, left: anchorPosition.left }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Card sx={{ maxWidth: 400, minWidth: 200 }}>
          <CardHeader
            action={
              <IconButton aria-label="close" onClick={handleClosed}>
                <span className="material-icons">close</span>
              </IconButton>
            }
            subheader={<>Provisional Suspension</>}
          />
          <Divider />
          <CardContent>
            <div className="p-2">
              <Autocomplete
                size="small"
                id="period"
                defaultValue={null}
                value={period || null}
                options={periods}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, period) => {
                  setPeriod(period || null);
                  setFormData({
                    ...formData,
                    period: period?.id || null,
                    effectedFrom: null,
                    effectedTo: null,
                  });
                  setErrors({
                    ...errors,
                    periodError: false,
                  });
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, period) => (
                  <Box component="li" {...props}>
                    {period.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Select period"
                    {...params}
                    label="Select period"
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
              {errors.periodError && (
                <small className="text-danger ">Period is required </small>
              )}
            </div>

            <div className="p-2">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Effected From"
                  inputFormat="dd/MM/yyyy"
                  minDate={moment(
                    caseRequest?.request?.currentDate || new Date(),
                  ).subtract(30, "days")}
                  maxDate={moment(
                    caseRequest?.request?.currentDate || new Date(),
                  ).add(30, "days")}
                  value={formData.effectedFrom}
                  onChange={(date) => {
                    if (!period) {
                      showError("Please select period first!");
                    } else {
                      setFormData({
                        ...formData,
                        effectedFrom: date,
                        effectedTo: moment(date).add(period?.days, "days"),
                      });

                      setErrors({
                        ...errors,
                        effectedFromError: false,
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      error={errors.effectedFromError}
                      onKeyDown={(e) => e.preventDefault()}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                />

                {errors.effectedFromError && (
                  <small className="text-danger mt-1">
                    The date is required{" "}
                  </small>
                )}
              </LocalizationProvider>
            </div>

            <div className="p-2">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="Effected To"
                  inputFormat="dd/MM/yyyy"
                  disabled={formData?.effectedFrom}
                  value={formData.effectedTo}
                  onChange={(date) => {
                    setFormData({
                      ...formData,
                      effectedTo: date,
                    });

                    setErrors({
                      ...errors,
                      effectedToError: false,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      error={errors.effectedToError}
                      onKeyDown={(e) => e.preventDefault()}
                      fullWidth
                      size="small"
                      {...params}
                    />
                  )}
                />

                {errors.effectedToError && (
                  <small className="text-danger mt-1">
                    The date is required{" "}
                  </small>
                )}
              </LocalizationProvider>
            </div>
          </CardContent>

          <CardActions
            disableSpacing
            className="py-3 d-flex justify-content-center"
          >
            <Button
              disabled={isLoading}
              variant="contained"
              color="primary"
              onClick={() => {
                if (!formValidator()) {
                  onCallback(
                    {
                      ...formData,
                    },
                    handleClosed,
                  );
                }
              }}
            >
              {isLoading ? "Wait.." : "Next"}
            </Button>
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

const GiveSanctionButton = (props) => {
  const { caseRequest, disabled, onInitiateSanctionLetter } = props;

  const [currentSanction, setCurrentSanction] = useState(
    caseRequest?.faults?.length === 1 ? caseRequest?.faults[0] : null,
  );
  const periods = [
    { id: 1, name: "1 month", days: 30 },
    { id: 2, name: "2 months", days: 60 },
    { id: 3, name: "3 months", days: 90 },
  ];
  const [showLetter, setShowLetter] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [period, setPeriod] = useState(null);
  const [enableToFillLetter, setEnableToFillLetter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [faultSanctions, setFaultSanctions] = useState([]);

  const [requiredFields, setRequiredFields] = useState({
    sanctionEffectedFrom: false,
    sanctionEffectedTo: false,
    period: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);

  const handleGiveSanction = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseGiveSanction = () => {
    setAnchorEl(null);
  };

  const [formData, setFormData] = useState({
    caseId: caseRequest?.request?.id || "",
    reason: "",
    sanctionId: "",
    sanctionEffectedFrom: null,
    sanctionEffectedTo: null,
    period: 0,
  });
  useEffect(() => {
    let faults = [
      ...new Map(
        caseRequest?.faults.map((item) => [item.faultSanctionId, item]),
      ).values(),
    ];

    setCurrentSanction(faults?.length === 1 ? faults[0] : null);
    setFaultSanctions([...faults]);
  }, [caseRequest, setFaultSanctions]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sanctionId: currentSanction?.faultSanctionId,
    }));
    setRequiredFields({
      sanctionEffectedFrom: [3, 4].includes(currentSanction?.faultSanctionId),
      sanctionEffectedTo: [3].includes(currentSanction?.faultSanctionId),
      period: [3].includes(currentSanction?.faultSanctionId),
    });
  }, [currentSanction]);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [errors, setErrors] = useState({
    hasError: false,
    sanctionEffectedFromError: false,
    sanctionEffectedToError: false,
    periodError: false,
    reasonHasError: false,
  });
  const formValidator = () => {
    const error = {
      hasError: false,
      periodError: false,
      sanctionEffectedFromError: false,
      sanctionEffectedToError: false,
      reasonHasError: false,
    };

    if (!formData.reason) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    if (requiredFields.sanctionEffectedFrom && !formData.sanctionEffectedFrom) {
      error.sanctionEffectedFromError = true;
      error.hasError = true;
    }

    if (requiredFields.sanctionEffectedTo && !formData.sanctionEffectedTo) {
      error.sanctionEffectedToError = true;
      error.hasError = true;
    }
    if (requiredFields.period && !formData.period) {
      error.periodError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill the required field");
      return true;
    }
    return false;
  };
  // console.log(currentSanction);
  return (
    <>
      <Button
        variant="contained"
        color="success"
        aria-describedby={id}
        disabled={disabled}
        onClick={handleGiveSanction}
        style={{ marginRight: "10px", textTransform: "none" }}
        startIcon={<CheckCircleOutlineIcon />}
      >
        Click here to initiate sanction
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseGiveSanction}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Card sx={{ maxWidth: 400, minWidth: 200 }}>
          <CardHeader
            action={
              <IconButton aria-label="close" onClick={handleCloseGiveSanction}>
                <span className="material-icons">close</span>
              </IconButton>
            }
            subheader={<>Sanction{faultSanctions.length > 1 && "s"}</>}
          />
          <Divider />
          <CardContent>
            <div className="card service-card valid mb-2 mt-3">
              <div
                className="card-header  d-flex justify-content-between align-items-center"
                style={{ padding: "0.25rem 1.2rem" }}
              >
                Select sanction
              </div>
              <div className="card-body">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="female"
                    name="radio-buttons-group"
                    className="p-0 m-0"
                  >
                    {faultSanctions?.map((fault, index) => (
                      <FormControlLabel
                        key={index + fault.faultSanctionId}
                        value={fault.faultSanctionId}
                        control={<Radio />}
                        label={fault.faultSanctionName}
                        onChange={() => {
                          setFormData({
                            ...formData,
                            period: 0,
                            sanctionEffectedFrom: null,
                            sanctionEffectedTo: null,
                          });
                          setCurrentSanction(fault);
                        }}
                        checked={currentSanction === fault}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            {requiredFields.period && (
              <div className="p-2">
                <Autocomplete
                  size="small"
                  id="period"
                  disabled={!currentSanction}
                  defaultValue={null}
                  value={period || null}
                  options={periods}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(event, period) => {
                    setPeriod(period || null);
                    setFormData({
                      ...formData,
                      period: period?.id || null,
                      sanctionEffectedFrom: null,
                      sanctionEffectedTo: null,
                    });
                    setErrors({
                      ...errors,
                      periodError: false,
                    });
                  }}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, period) => (
                    <Box component="li" {...props}>
                      {period.name}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Select period"
                      {...params}
                      label="Select period"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
                {errors.periodError && (
                  <small className="text-danger ">Period is required </small>
                )}
              </div>
            )}
            {requiredFields.sanctionEffectedFrom && (
              <div className="p-2">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Effected From"
                    inputFormat="dd/MM/yyyy"
                    minDate={moment(
                      caseRequest?.request?.currentDate || new Date(),
                    ).subtract(30, "days")}
                    maxDate={moment(
                      caseRequest?.request?.currentDate || new Date(),
                    ).add(30, "days")}
                    disabled={!currentSanction}
                    value={formData.sanctionEffectedFrom}
                    onChange={(date) => {
                      if (requiredFields.period && !period) {
                        showError("Please select period first!");
                      } else {
                        setFormData({
                          ...formData,
                          sanctionEffectedFrom: date,
                          sanctionEffectedTo: moment(date).add(
                            currentSanction?.faultSanctionId === 4
                              ? 1825
                              : period?.days,
                            "days",
                          ),
                        });

                        setErrors({
                          ...errors,
                          sanctionEffectedFromError: false,
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={
                          requiredFields.sanctionEffectedFrom &&
                          errors.sanctionEffectedFromError
                        }
                        onKeyDown={(e) => e.preventDefault()}
                        required={requiredFields.sanctionEffectedFrom}
                        fullWidth
                        size="small"
                        {...params}
                      />
                    )}
                  />

                  {errors.sanctionEffectedFromError && (
                    <small className="text-danger mt-1">
                      The date is required{" "}
                    </small>
                  )}
                </LocalizationProvider>
              </div>
            )}

            {formData.sanctionEffectedFrom && (
              <div className="p-2">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Effected To"
                    inputFormat="dd/MM/yyyy"
                    disabled={
                      !currentSanction ||
                      !requiredFields.sanctionEffectedTo ||
                      formData?.sanctionEffectedFrom
                    }
                    value={formData.sanctionEffectedTo}
                    onChange={(date) => {
                      setFormData({
                        ...formData,
                        sanctionEffectedTo: date,
                      });

                      setErrors({
                        ...errors,
                        sanctionEffectedToError: false,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={
                          requiredFields.sanctionEffectedTo &&
                          errors.sanctionEffectedToError
                        }
                        onKeyDown={(e) => e.preventDefault()}
                        required={requiredFields.sanctionEffectedTo}
                        fullWidth
                        size="small"
                        {...params}
                      />
                    )}
                  />

                  {errors.sanctionEffectedToError && (
                    <small className="text-danger mt-1">
                      The date is required{" "}
                    </small>
                  )}
                </LocalizationProvider>
              </div>
            )}

            <div className="p-2">
              <TextField
                error={errors.reasonHasError}
                fullWidth
                size="small"
                name="reason"
                required={true}
                multiline
                rows={3}
                value={formData.reason}
                label={`Reason`}
                placeholder={`Reason`}
                inputProps={{ maxLength: 300 }}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    reason: e.target.value,
                  });

                  setErrors({
                    ...errors,
                    reasonHasError: false,
                  });
                }}
              />
              <small className="text-right float-right text-primary w-100">
                Should not exceed the 300-character limit.
              </small>
              {errors.reasonHasError && (
                <small className="text-danger mb-1">Reason</small>
              )}
            </div>
          </CardContent>

          <CardActions
            disableSpacing
            className="py-3 d-flex justify-content-center"
          >
            <Button
              disabled={!currentSanction || isLoading}
              variant="contained"
              color="primary"
              onClick={() => {
                if (!formValidator()) {
                  onInitiateSanctionLetter(
                    formData,
                    caseRequest,
                    (isLoading, data) => {
                      setIsLoading(isLoading);
                      if (data) {
                        setSelectedLetter(data);
                        setShowLetter(true);
                        setEnableToFillLetter(true);
                        handleCloseGiveSanction();
                      }
                    },
                  );
                }
              }}
            >
              {isLoading ? "Wait.." : "Next"}
            </Button>
          </CardActions>
        </Card>
      </Popover>

      {showLetter && selectedLetter && caseRequest && (
        <ViewLetterDialog
          showLetter={showLetter}
          selectedLetter={selectedLetter}
          setShowLetter={setShowLetter}
          setEnableToFillLetter={setEnableToFillLetter}
          employee={{
            lastName: caseRequest?.request?.lastName,
            firstName: caseRequest?.request?.firstName,
            phoneNumber: caseRequest?.request?.phoneNumber,
            email: caseRequest?.request?.email,
            entityName: caseRequest?.request?.entityName,
            entitySectorId: caseRequest?.request?.entitySectorId,
            appointingAuthorityPlanningEntityId:
              caseRequest?.request?.appointingAuthorityPlanningEntityId,
            planningEntityId: caseRequest?.request?.planningEntityId,
          }}
          decisionLevel={caseRequest?.request?.decisionLevel}
          action={<></>}
          enableToFillLetter={enableToFillLetter}
        />
      )}
    </>
  );
};
